import React from 'react';
import { Trophy, XCircle } from 'lucide-react';
import type { GameStats } from '../types';

interface StatsPanelProps {
  stats: GameStats;
  onReset: () => void;
}

export function StatsPanel({ stats, onReset }: StatsPanelProps) {
  const accuracy = stats.correct + stats.incorrect === 0 
    ? 0 
    : (stats.correct / (stats.correct + stats.incorrect) * 100).toFixed(1);

  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">Statystyki</h2>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="flex items-center">
            <Trophy className="w-5 h-5 text-green-500 mr-2" />
            Poprawne:
          </span>
          <span className="font-bold">{stats.correct}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="flex items-center">
            <XCircle className="w-5 h-5 text-red-500 mr-2" />
            Niepoprawne:
          </span>
          <span className="font-bold">{stats.incorrect}</span>
        </div>
        <div className="flex items-center justify-between">
          <span>Skuteczność:</span>
          <span className="font-bold">{accuracy}%</span>
        </div>
        <button
          onClick={onReset}
          className="w-full mt-4 bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
        >
          Resetuj postęp
        </button>
      </div>
    </div>
  );
}